import React, { useState, useEffect, Component } from 'react';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { SelectButton } from 'primereact/selectbutton';
import { Tooltip } from 'primereact/tooltip';
import 'primereact/resources/themes/nova/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

class KPITreeTable extends Component {

    constructor(props) {
        super(props);

        this.state = {
            globalFilter: '',
            filterMode: 'lenient',
            data: [],
            header: [],
            expandedKeys: {}
        }
    }

    componentDidMount() {
        this.setState({
            data: JSON.parse(this.props.data),
            header: JSON.parse(this.props.header)
        });
    }

    rowClassName(node) {
        return {'font-weight-bold': (node.children && node.children.length > 0)};
    }

    colStyle(index) {
        if(index === (this.state.header.length - 1)) {
            return {'width': '17%'};
        } else if (index === 0 || index === 1) {
            return {'width': '22%'};
        } else {
            return {};
        }
    }

    render() {
        const anyExpanded = Object.keys(this.state.expandedKeys).length > 0;
        return (
            <div>
                <div className="d-flex justify-content-start pb-1 font-weight-light">
                    <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Search" />
                </div>
                <TreeTable value={this.state.data} rowClassName={this.rowClassName} globalFilter={this.state.globalFilter} filterMode={this.state.filterMode} tableStyle={{ minWidth: '50rem' }} className={anyExpanded ? '' : 'kpi-tree-table-header-collapsed'} expandedKeys={this.state.expandedKeys} onToggle={(e) => this.setState({ expandedKeys: e.value })}>
                    {Array.isArray(this.state.header) && this.state.header.map((element, index) => <Column field={element.value} header={<span>{element.label}{element.help ? <i className="pi pi-question-circle pl-1" data-pr-tooltip={element.help}><Tooltip target=".pi-question-circle"/></i> : <></>}</span>} expander={index === 0} style={this.colStyle(index)}></Column>)}
                </TreeTable>
            </div>
        );
    }
}

export default KPITreeTable;